import { set } from "browser-cookies";
import type { CookieOptions } from "browser-cookies";
import { isClient } from "@vfuk/core-helpers";

/**
 *  use browser-cookies library instead of using @vfuk/core-helpers
 * to be able to pass more cookies config like domain
 */
export const setCookie = (
  name: string,
  value: string,
  options?: Omit<CookieOptions, "secure">
) => {
  let secure = false;

  if (isClient() && document && document.location) {
    secure = document.location.protocol.toLowerCase().includes("s");
  }

  const cookieOptions = options ? { ...options, secure } : { secure };
  set(name, value, cookieOptions);
};
